import {EntityBase} from "../../shared/entity/EntityBase";
import dayjs from "dayjs";

const NOTICE_FIELDS = {
    seq: { type: parseInt, defaultValue: 0 },
    fileName: { defaultValue: '' },
    noticeDate: { defaultValue: dayjs().format('YYYY-MM-DD') },
    notice: { defaultValue: {} },
    memo: { defaultValue: '' },
    created: { defaultValue: dayjs().format('YYYY-MM-DD HH:mm:ss') }
};

export class NoticeEntity extends EntityBase{
    constructor(data = {}) {
        super(data, NOTICE_FIELDS);

        this.errors  = [
            { condition: () => this.fileName.length <= 0, message: '파일 이름을 입력해야 합니다.' },
            { condition: () => Object.values(this.notice).length <= 0, message: '하나 이상의 공지를 입력 해야합니다.' },
        ];
    }
}